var React = require('react');

function Shape1 (props) {
    return React.createElement("svg",props,React.createElement("g",null,React.createElement("path",{"fill":"#E4D3C8","d":"M66.776,26.816c25.906,11.611,39.045,8.813,40.607,30.843\n\t\tc1.564,22.031-4.102,53.104-34.313,52.989c-30.215-0.117-43.432-7.04-59.167-22.775C-1.832,72.136-0.575,55.726,0.686,41.9\n\t\tC1.943,28.076,12.645,1.642,19.567,0.067C26.492-1.508,62.558,24.927,66.776,26.816"})));
}

Shape1.defaultProps = {"version":"1.1","id":"Warstwa_1","x":"0px","y":"0px","width":"107.619px","height":"110.648px","viewBox":"0 0 107.619 110.648","enableBackground":"new 0 0 107.619 110.648","xmlSpace":"preserve"};

module.exports = Shape1;

Shape1.default = Shape1;
